module.exports = __webpack_public_path__ + "img/product_45.16e4584.webp";